const ActionTypes = {
	P_LINK: "plink",
	CATALOG_LINK: "cataloglink",
	INLINE_DISPLAY: "inline display",
	SEARCH: "search",
	EXTERNAL_LINK: "external link"
}

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/data/types/ActionTypes.js